import BaseService from "../../services/BaseService";
import RecentUserAccountService from "../../services/RecentUserAccountService";

export default {
  state: {
    recentUserAccounts: [],
    recentUserAccountsLoaded: false,
  },
  getters: {
    recentUserAccounts: (state) => {
      return state.recentUserAccounts;
    },
    recentUserAccountsLoaded: (state) => {
      return state.recentUserAccountsLoaded;
    },
  },
  mutations: {
    SET_RECENT_USER_ACCOUNTS(state, accounts) {
      state.recentUserAccounts = accounts;
    },
    SET_RECENT_USER_ACCOUNTS_LOADED(state) {
      state.recentUserAccountsLoaded = true;
    },
  },
  actions: {
    async loadRecentUserAccounts({ commit }) {
      let result = await RecentUserAccountService.index();

      if (result.status === BaseService.STATUS_200) {
        commit("SET_RECENT_USER_ACCOUNTS", result.data);
        commit("SET_RECENT_USER_ACCOUNTS_LOADED");
      }
    },
  },
};
